module.exports = __webpack_public_path__ + "static/media/rightFacingBack.5e8be239.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/rightFacingBack.svg
// module id = 120
// module chunks = 0